var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BtnZzimTemplate',{attrs:{"title":_vm.title,"wrapperClass":'check-like ' + _vm.getIconStyle,"check-state":_vm.value,"toggleFn":_vm.toggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }